import React from 'react';
import { Alert, Link, Typography } from '@mui/material';
import { getDetailOfCaseInCRM } from 'features/common/helpers';
import { formatTransactionAmount } from 'features/transaction-details/helpers';
import { RefundImpactNavigationButtons } from '../RefundImpactNavigationButtons';

interface RefundSaleOrderImpactAlertProps {
	dealId: number;
	saleOrderId?: string | null;
	amount: number;
	coinCode: string;
	onNavigationError?: (message: string) => void;
}

export const RefundSaleOrderImpactAlert = ({
	dealId,
	saleOrderId,
	amount,
	coinCode,
	onNavigationError,
}: RefundSaleOrderImpactAlertProps): JSX.Element => {
	const caseUrl = getDetailOfCaseInCRM(dealId);
	const saleOrderHref = saleOrderId ? `/salesorder/${saleOrderId}` : null;

	const amountLabel = amount > 0 ? formatTransactionAmount(amount, coinCode) : `el monto que devuelvas (${coinCode})`;

	return (
		<Alert severity="info" variant="outlined">
			<Typography variant="body2" component="div">
				Al confirmar, <strong>{amountLabel}</strong> dejarán de estar autorizados en esta transacción y se reflejarán
				como <strong>pendiente de pago</strong> en la{' '}
				{saleOrderHref ? (
					<Link href={saleOrderHref} target="_blank" rel="noopener noreferrer" underline="hover">
						orden de venta
					</Link>
				) : (
					<strong>orden de venta</strong>
				)}{' '}
				del{' '}
				<Link href={caseUrl} target="_blank" rel="noopener noreferrer" underline="hover">
					caso de venta {dealId}
				</Link>
				.
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
				Avisá al vendedor con un comentario en el caso y cambiá el estado a <strong>«Necesita agente»</strong>.
			</Typography>
			<RefundImpactNavigationButtons dealId={dealId} saleOrderId={saleOrderId} onError={onNavigationError} />
		</Alert>
	);
};
